module.exports = __webpack_public_path__ + "img/img-5.78779ae0.jpg";